<script setup>
import { useMenuStore } from "@/stores/menu";
import { useAuthStore } from "@stores/auth";
import { watch, onMounted, onUnmounted } from "vue";

const props = defineProps({
  isLoading: Boolean,
});

const authStore = useAuthStore();
const menuStore = useMenuStore();
const runtimeConfig = useRuntimeConfig();
const router = useRouter();
const apiUrl = runtimeConfig.public.API_URL;
const integrationValue = runtimeConfig.public.ALTENAR_SKIN;

const isMcGames = apiUrl === 'https://app.mcgames.bet';

let token = "";
let isSportsbookInitialized = false; // Estado para controlar a inicialização do Sportsbook

// Inicializa o Sportsbook com os banners e widgets
const initSportsbook = async (withToken = "") => {
  if (window.altenarWSDK && !isSportsbookInitialized) {
    const config = {
      integration: integrationValue,
      culture: "pt-BR",
      oddsFormat: 0,
      token: withToken
    };

    // Inicializa o Sportsbook apenas uma vez
    await window.altenarWSDK.init(config);

    window.WSM = await window.altenarWSDK.addWidget({
      widget: "WSportMenu",
      container: document.getElementById("WSportMenu"),
      props: {
        onCategorySelect: (e) => {
          const categoryPath = e.categoryIds.join(',');
          router.push(`/sports#/category/${categoryPath}`);
          menuStore.toggle();
        },
        onChampionshipSelect: (e) => {
          const championshipPath = e.championshipIds.join(',');
          router.push(`/sports#/championship/${championshipPath}`);
          menuStore.toggle();
        }
      }
    });

    isSportsbookInitialized = true; // Marca como inicializado
  }
};

// Remove o Sportsbook da página
const removeSportsbook = () => {
  if (window.WSM) {
    window.WSM.remove();
    isSportsbookInitialized = false; // Redefine o estado de inicialização
  }
};

// Manipula a inicialização e remoção do Sportsbook ao montar/desmontar o componente
onMounted(async () => {
  token = await authStore.getSportBookToken();
  await initSportsbook(token);  // Inicializa o Sportsbook com o token, se disponível

  // Observa mudanças no login do usuário e atualiza o token no Sportsbook
  watch(
    () => authStore.isLoggedIn,
    async (isLoggedIn) => {
      if (isLoggedIn) {
        token = await authStore.getSportBookToken();
        window.altenarWSDK.set({ token });  // Apenas atualiza o token
      } else {
        window.altenarWSDK.set({ token: "" });  // Remove o token no logout
      }
    }
  );
});

onUnmounted(() => {
  removeSportsbook();
});
</script>

<template>
  <div id="WSportMenu" />
</template>
